import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import MaintenanceBanner from "./MaintenanceBanner";
import UpdateNotice from "./UpdateNotice";

export default function Layout() {
  // A column at least as tall as the window, with the page in the middle, so
  // the footer sits at the bottom of the screen on a short page rather than
  // partway up it — and below the content on a long one.
  return (
    <div className="min-h-screen flex flex-col">
      {/* Renders nothing; it only watches the address and moves the scroll. */}
      <ScrollToTop />
      <Navbar />
      {/* Above the page rather than inside it: somebody about to upload a file
          is on a project page, and a notice they have to go and find is one
          they read after the refusal instead of before it. Renders nothing
          unless maintenance is on. */}
      <MaintenanceBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {/* A dialog, so where it sits here changes nothing on the page. It is in
          the layout because this is the one component every signed-in page
          shares. Renders nothing once the current update has been seen. */}
      <UpdateNotice />
    </div>
  );
}
